import React from 'react';
import { Moon, Sun } from 'lucide-react';
import IconButton from './IconButton';
import { useTheme } from './theme/ThemeProvider';

/** Switches between light and dark mode; shows the mode it switches to. */
const ThemeToggle: React.FC<{ className?: string }> = ({ className }) => {
  const { theme, toggleTheme } = useTheme();
  return (
    <IconButton
      icon={theme === 'dark' ? Sun : Moon}
      label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      onClick={toggleTheme}
      className={className}
    />
  );
};

export default ThemeToggle;
